const Cookies = {
  /**
   * Sets a cookie with the provided key/value. Optional expiration in days
   * @param {string} key - cookie key
   * @param {string} value - value will be uri encoded
   * @param {number?} expiresDays - optional expiration date, session cookie if omitted
   */
  set: (key, value, expiresDays) => {
    let expiry = '';
    if(expiresDays) {
      const date = new Date();
      date.setTime(date.getTime() + (expiresDays * 24 * 60* 60 * 1000));
      expiry = `; expires=${date.toUTCString()}`;
    }
    document.cookie =  `${key}=${encodeURIComponent(value)}; path=/${expiry}`;
  },
  /**
   * Get a cookie by its key. Values will be RUI decoded
   * @param {string} key
   * @returns {string|undefined}
   */
  get: (key) => {
    const cookies = document.cookie.split(';');
    const fullKey = `${key}=`;
    return cookies.map(c => c.trimLeft()) // gets rid of leading spaces
      .filter(c => c.indexOf(fullKey) === 0)
      .map( c => decodeURIComponent(c.substring(fullKey.length, c.length)))[0]; // [0] should be fine as multiple cookies with the same name aren't allowed
  },
  /**
   * Clears a cookie by name
   * @param {string} key
   */
  clear: (key) => {
    // overwrite with negative expiration to remove
    Cookies.set(key, "", -1);
  }
};

export default Cookies;
